import "./Loader.css";

function Loader() {
  return (
    <div id="backdrop">
      <div className="text-center">
        <div className="loader"></div>
      </div>
    </div>
  );
}

export default Loader;
